export enum Status {
  Success = 'Success',
  Error = 'Error',
  Failed = 'Failed',
  NotSent = 'Not Sent',
}
